/**
 * @file Image viewing modal.
 */

import React from 'react';
import PropTypes from 'prop-types';

import withModal from './withModal';
import { PHOTO_VIEW_MODAL } from '../../../constants/modals';
import { getHiResPhotoUrl } from '../../../util/photo';

const propTypes = {
  photoUrl: PropTypes.string,
  photo: PropTypes.shape({
    id: PropTypes.string,
    thumbnail_urls: PropTypes.array.isRequired,
  }),
  actionProps: PropTypes.shape({
    photo: PropTypes.shape({
      id: PropTypes.string,
      thumbnail_urls: PropTypes.array.isRequired,
    }),
    photoUrl: PropTypes.string,
  }),
  children: PropTypes.func,
  className: PropTypes.string,
};

const PhotoViewModal = ({
  photoUrl,
  photo,
  children = () => {},
  className,
  actionProps: { photo: actionPhoto, photoUrl: actionPhotoUrl } = {},
}) => {
  const photoActual = actionPhoto || photo;
  const photoUrlActual = actionPhotoUrl || photoUrl;
  const src = photoActual ? getHiResPhotoUrl(photoActual) : photoUrlActual;

  return (
    <div className={className}>
      <img src={src} alt="" />

      {children(photoActual)}
    </div>
  );
};

PhotoViewModal.propTypes = propTypes;

export default withModal(PhotoViewModal, {
  name: PHOTO_VIEW_MODAL,
  size: 'sm',
  className: 'modal-photo-view',
});
